export const MODAL__ACTIONS = {
  OPEN: "OPEN",
};

export const AUTHENTICATION__ACTIONS = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  FORCELOGOUT: "FORCELOGOUT",
  GETTIME: "GETTIME",
  INITIALIZE_AUTH: "INITIALIZE_AUTH",
};

export const ADMINNOTIFICATION__ACTIONS = {
  ADMINGETNOTIFICATION: "ADMINGETNOTIFICATION",
  ADMINCREATENOTIFICATION: "ADMINCREATENOTIFICATION",
  ADMINUPDATENOTIFICATION: "ADMINUPDATENOTIFICATION",
  ADMINMARKASREADNOTIFICATION: "ADMINMARKASREADNOTIFICATION",
  SET_POLLING_INTERVAL: "SET_POLLING_INTERVAL",
  STOP_POLLING_INTERVAL: "STOP_POLLING_INTERVAL",
  ADDCLIENTNOTIFICATION: "ADDCLIENTNOTIFICATION",
};

export const DASHBOARDAPIREQ__ACTIONS = {
  TOTALPARTNERS: "TOTALPARTNERS",
  TOTALLIVEACCOUNTS: "TOTALLIVEACCOUNTS",
};

export const ALLNEWUSER__ACTIONS = {
  INSERTNEWUSER: "INSERTNEWUSER",
  REMOVENEWUSER: "REMOVENEWUSER",
  GETALLPARTNERS: "GETALLPARTNERS",
  GETALLCLIENTS: "GETALLCLIENTS",
};

export const LOGOUT__DIALOG__ACTIONS = {
  SHOWDIALOG: "SHOWDIALOG",
  HIDEDIALOG: "HIDEDIALOG",
};

export const REGISTEREDUSER__ACTIONS = {
  REGISTEREDUSER: "REGISTEREDUSER",
  UPDATEIBSTATUS: "UPDATEIBSTATUS",
  DASHBOARDREGISTEREDUSERS: "DASHBOARDREGISTEREDUSERS",
  DASHBOARDTOTALUSERS: "DASHBOARDTOTALUSERS",
  ALLREGISTEREDUSERUSER: "ALLREGISTEREDUSERUSER",
};

export const COUNTRIES__ACTIONS = {
  COUNTRIES: "COUNTRIES",
};

export const CITIES__ACTIONS = {
  CITIES: "CITIES",
};

export const STATES__ACTIONS = {
  STATES: "STATES",
};

export const NEWUSER__ACTIONS = {
  NEWUSER: "NEWUSER",
};

export const AGREEMENTS__ACTIONS = {
  CREATEAGREEMENT: "CREATEAGREEMENT",
  GETCLIENTSAGREEMENTSHISTORIES: "GETCLIENTSAGREEMENTSHISTORIES",
  GETPARTNERSAGREEMENTSHISTORIES: "GETPARTNERSAGREEMENTSHISTORIES",
  UPDATECLIENTSAGREEMENTSTATUS: "UPDATECLIENTSAGREEMENTSTATUS",
  GETTRADINGAGREEMENTS: "GETTRADINGAGREEMENTS",
  GETOTHERSAGREEMENTS: "GETOTHERSAGREEMENTS",
  GETIBAGREEMENTS: "GETIBAGREEMENTS",
  ACCEPTEDAGREEMENTS: "ACCEPTEDAGREEMENTS",
  NOTACCEPTEDAGREEMENTS: "NOTACCEPTEDAGREEMENTS",
};

export const PARTNERPAYMENTMETHOD__ACTIONS = {
  PARTNER_PAYMENT_METHODS: "PARTNER_PAYMENT_METHODS",
  CREATE_PARTNER_PAYMENT_METHOD: "CREATE_PARTNER_PAYMENT_METHOD",
  EDIT_PARTNER_PAYMENT_METHOD: "EDIT_PARTNER_PAYMENT_METHOD",
  DELETE_PARTNER_PAYMENT_METHOD: "DELETE_PARTNER_PAYMENT_METHOD",
};

export const CLIENTS_DOCUMENTS__ACTIONS = {
  CLIENTS_DOCUMENTS: "CLIENTS_DOCUMENTS",
  UPLOAD_DOCUMENTS: "UPLOAD_DOCUMENTS",
  VERIFYDOC: "VERIFYDOC",
};

export const PROFILE__ACTIONS = {
  GETPROFILE: "GETPROFILE",
  FETCHDOCUMENTS: "FETCHDOCUMENTS",
  UPLOADDOCUMENT: "UPLOADDOCUMENT",
  BUSINESSAMOUNT: "BUSINESSAMOUNT",
};

export const BLOCKEDUSER__ACTIONS = {
  BLOCKEDUSER: "BLOCKEDUSER",
  UNBLOCKUSER: "UNBLOCKUSER",
};

export const DEMOACCOUNTS__ACTIONS = {
  DEMOACCOUNTS: "DEMOACCOUNTS",
};

export const TESTINGACCOUNTS__ACTIONS = {
  TESTINGACCOUNTS: "TESTINGACCOUNTS",
  CREATETESTINGACCOUNT: "CREATETESTINGACCOUNT",
};

export const LIVEACCOUNTS__ACTIONS = {
  LIVEACCOUNTS: "LIVEACCOUNTS",
};

// inactive and low balance acounts actions
export const INACTIVEACCOUNTS__ACTIONS = {
  INACTIVEACCOUNTS: "INACTIVEACCOUNTS",
  INACTIVEACCOUNTDISABLE: "INACTIVEACCOUNTDISABLE",
};
export const LOWBALANCEACCOUNTS__ACTIONS = {
  LOWBALANCEACCOUNTS: "LOWBALANCEACCOUNTS",
  LOWBALANCEACCOUNTDISABLE: "LOWBALANCEACCOUNTDISABLE",
};

// account disable action
export const ACCOUNTDISABLE__ACTIONS = {
  ACCOUNTDISABLE: "ACCOUNTDISABLE",
};

export const ACCOUNTTYPES__ACTIONS = {
  ACCOUNTTYPES: "ACCOUNTTYPES",
};

export const USERLOGINACTIVITY__ACTIONS = {
  USERLOGINACTIVITY: "USERLOGINACTIVITY",
};

export const MARKETTINGTOOLS__ACTIONS = {
  BANNERCATEGORIES: "BANNERCATEGORIES",
  BANNERSIZES: "BANNERSIZES",
  BANNERS: "BANNERS",
  CREATEBANNER: "CREATEBANNER",
  DELETEBANNER: "DELETEBANNER",
  UPDATEBANNER: "UPDATEBANNER",
  BANNERSIZECREATE: "BANNERSIZECREATE",
  BANNERSIZEUPDATE: "BANNERSIZEUPDATE",
  BANNERSIZEDELETE: "BANNERSIZEDELETE",
};

export const CURRENCY__ACTIONS = {
  ACTIVECURRENCIES: "ACTIVECURRENCIES",
  UPDATECURRENCYSYMBOL: "UPDATECURRENCYSYMBOL",
  ACTIVECURRENCYGROUPS: "ACTIVECURRENCYGROUPS",
  UPDATECURRENCYGROUP: "UPDATECURRENCYGROUP",
  DELETEGROUP: "DELETEGROUP",
  CREATEGROUP: "CREATEGROUP",
  CREATESYMBOL: "CREATESYMBOL",
  DELETECURRENCY: "DELETECURRENCY",
  GETCURRECNCYUSDT: "GETCURRECNCYUSDT",
  UPDTECURRENCYUSDT: "UPDTECURRENCYUSDT"
};

export const COMPANYINFO__ACTIONS = {
  COMPANYINFO: "COMPANYINFO",
  LOGINPAGEINFO: "LOGINPAGEINFO",
};

export const COMMISSIONSETTINGS__ACTIONS = {
  COMMISSIONSETTINGS: "COMMISSIONSETTINGS",
  CREATECOMMISSIONSETTINGS: "CREATECOMMISSIONSETTINGS",
};

export const PARTNERWITHDRAW__ACTIONS = {
  DASHBOARDPARTNERWITHDRAW: "DASHBOARDPARTNERWITHDRAW",
  PARTNERWITHDRAW: "PARTNERWITHDRAW",
  CHANGESTATUS: "CHANGESTATUS",
  UPDATEWITHDRAW: "UPDATEWITHDRAW",
  PARTNERWITHDRAWEXCEL: "PARTNERWITHDRAWEXCEL",
};

export const LIVETRADES__ACTIONS = {
  LIVETRADES: "LIVETRADES",
  DASHBOARDLIVETRADES: "DASHBOARDLIVETRADES",
  LIVETRADESCHARTDATA: "LIVETRADESCHARTDATA",
};
export const USERLIVETRADES__ACTIONS = {
  USERLIVETRADES: "USERLIVETRADES",
};

export const CLOSEDTRADES__ACTIONS = {
  CLOSEDTRADES: "CLOSEDTRADES",
  DASHBOARDCLOSEDTRADES: "DASHBOARDCLOSEDTRADES",
  CLOSEDTRADESCHARTDATA: "CLOSEDTRADESCHARTDATA",
};

export const USERCLOSEDTRADES__ACTIONS = {
  USERCLOSEDTRADES: "USERCLOSEDTRADES",
};

export const SHORTDURATIONTRADES__ACTIONS = {
  SHORTDURATIONTRADES: "SHORTDURATIONTRADES",
  // DASHBOARDSMALLTRADES: "DASHBOARDSMALLTRADES",
};

export const TRANSACTIONS__ACTIONS = {
  TRXSUMMARIES: "TRXSUMMARIES",
  TRXSUMMARIESEXCEL: "TRXSUMMARIESEXCEL",
  TRXDEPOSITS: "TRXDEPOSITS",
  TRXWITHDRAWAL: "TRXWITHDRAWAL",
  UPDATEDEPOSIT: "UPDATEDEPOSIT",
  TRXDASHBOARDDEPOSITS: "TRXDASHBOARDDEPOSITS",
  TRXDASHBOARDWITHDRAWAL: "TRXDASHBOARDWITHDRAWAL",
  TRXINTERNALTRANSFER: "TRXINTERNALTRANSFER",
  TRXDASHBOARDINTERNALTRANSFER: "TRXDASHBOARDINTERNALTRANSFER",
  TRXCREDITIN: "TRXCREDITIN",
  TRXCREDITOUT: "TRXCREDITOUT",
  TRXDEPOSITEXCEL: "TRXDEPOSITEXCEL",
  TRXWITHDRAWALEXCEL: "TRXWITHDRAWALEXCEL",
};

export const RMSSETTINGS__ACTIONS = {
  RMSSETTINGS: "RMSSETTINGS",
  RMSGRAPH: "RMSGRAPH",
  PROFITREACHES: "PROFITREACHES",
  AUTOCREDITBACK: "AUTOCREDITBACK",
  UPDATEPROFITREACHES: "UPDATEPROFITREACHES",
  UPDATERMSSETTINGS: "UPDATERMSSETTINGS",
};

export const NEWS__ACTIONS = {
  GETNEWS: "GETNEWS",
  DELETENEWS: "DELETENEWS",
  UPDATENEWS: "UPDATENEWS",
  NEWSCATEGORIES: "NEWSCATEGORIES",
  SINGLENEWS: "SINGLENEWS",
  ADDNEWS: "ADDNEWS",
};

export const TICKETS__ACTIONS = {
  MESSAGES: "MESSAGES",
  REPLY: "REPLY",
  TOGGLE_TICKET: "TOGGLE_TICKET",
  DELETECOMMENT: "DELETECOMMENT",
  UPDATECOMMENT: "UPDATECOMMENT",
  MARKSEEN: "MARKSEEN",
};

export const MARKETINGDATA__ACTIONS = {
  GETMARKETINGUSERS: "GETMARKETINGUSERS",
  FILEUPLOAD: "FILEUPLOAD",
  SENDEMAIL: "SENDEMAIL",
  GETALLEMAIL: "GETALLEMAIL",
  GETEMAILSBYCATEGORY: "GETEMAILSBYCATEGORY",
};

export const SERVERCONFIG__ACTIONS = {
  SERVERCONFIG: "SERVERCONFIG",
  UPDATESERVERCONFIG: "UPDATESERVERCONFIG",
};

export const EMAILCONFIG__ACTIONS = {
  EMAILCONFIG: "EMAILCONFIG",
  UPDATEEMAILCONFIG: "UPDATEEMAILCONFIG",
};

export const LEVERAGE__ACTIONS = {
  LEVERAGE: "LEVERAGE",
  USERLEVERAGE: "USERLEVERAGE",
  CREATELEVERAGE: "CREATELEVERAGE",
  DELETELEVERAGE: "DELETELEVERAGE",
};

export const GENERALINFO__ACTIONS = {
  GENERALINFO: "GENERALINFO",
  UPDATEGENERALINFO: "UPDATEGENERALINFO",
  UPDATEGENERALINFOLOGO: "UPDATEGENERALINFOLOGO",
};

export const ACCGROUPS__ACTIONS = {
  ACCGROUPS: "ACCGROUPS",
  USERACCGROUPS: "USERACCGROUPS",
  UPDATEUSERACCGROUPS: "UPDATEUSERACCGROUPS",
  CREATEACCGROUPS: "CREATEACCGROUPS",
  UPDATEACCGROUPS: "UPDATEACCGROUPS",
  DELETEACCGROUPS: "DELETEACCGROUPS",
  GETCURRENCIESGROUP: "GETCURRENCIESGROUP",
};

export const BROKERSBANK__ACTIONS = {
  BROKERSBANK: "BROKERSBANK",
  GETBROKERSBANK: "GETBROKERSBANK",
  GETCURRENCIES: "GETCURRENCIES",
  UPDATEBANK: "UPDATEBANK",
};

export const CRYPTOADDRESS__ACTIONS = {
  GETCRYPTOADDRESS: "GETCRYPTOADDRESS",
  CREATECRYPTOADDRESS: "CREATECRYPTOADDRESS",
  UPDATECRYPTOADDRESS: "UPDATECRYPTOADDRESS",
};

export const ADMINS__ACTIONS = {
  GETADMINS: "GETADMINS",
  GETADMIN: "GETADMIN",
  GETROLES: "GETROLES",
  CREATEADMIN: "CREATEADMIN",
  UPDATEADMIN: "UPDATEADMIN",
  DELETEADMIN: "DELETEADMIN",
  GETLOGINACTIVITIES: "GETLOGINACTIVITIES",
  CREATEPERMISSION: "CREATEPERMISSION",
  CHANGETHEME: "CHANGETHEME",
  GETALLMODULES: "GETALLMODULES",
};

export const REGISTERUSERDETAILS__ACTIONS = {
  REGPERSONALINFO: "REGPERSONALINFO",
  ACCOUNTDESCENDANTS: "ACCOUNTDESCENDANTS",
  UPDATEREGPERSONALINFO: "UPDATEREGPERSONALINFO",
  CLIENTDEPOSITS: "CLIENTDEPOSITS",
  CLIENTWITHDRAWS: "CLIENTWITHDRAWS",
  CLIENTINTTRXS: "CLIENTINTTRXS",
  CLIENTCREDITINOUT: "CLIENTCREDITINOUT",
  CLIENTMT5ACCOUNTANDTYPES: "CLIENTMT5ACCOUNTANDTYPES",
  CHANGECLIENTMT5ACCOUNTANDTYPES: "CHANGECLIENTMT5ACCOUNTANDTYPES",
  CHANGECLIENTLEVERAGE: "CHANGECLIENTLEVERAGE",
  CHANGECLIENTPASSWORD: "CHANGECLIENTPASSWORD",
  CHANGECLIENTLOGINPASSWORD: "CHANGECLIENTLOGINPASSWORD",
  CLIENTTRADINGACCOUNTS: "CLIENTTRADINGACCOUNTS",
  USERTRADINGACCOUNTS: "USERTRADINGACCOUNTS",
  CREATECLIENTCREDITINOUT: "CREATECLIENTCREDITINOUT",
  CREATECLIENTINTX: "CREATECLIENTINTX",
  PAYMENTSYSTEMFORDEPOSIT: "PAYMENTSYSTEMFORDEPOSIT",
  PAYMENTSYSTEMFORWITHDRAW: "PAYMENTSYSTEMFORWITHDRAW",
  CREATECLIENTDEPOSIT: "CREATECLIENTDEPOSIT",
  CREATECLIENTWITHDRAW: "CREATECLIENTWITHDRAW",
  GETMANAGERS: "GETMANAGERS",
  ASSIGNUSER: "ASSIGNUSER",
  USERDEMOACCOUNTS: "USERDEMOACCOUNTS",
  USERDOCUMENTS: "USERDOCUMENTS",
  BROKERSBANK: "BROKERSBANK",
  CREATELIVEACCOUNT: "CREATELIVEACCOUNT",
  CREATEDEMOACCOUNT: "CREATEDEMOACCOUNT",
  UPDATEMT5ACCOUNT: "UPDATEMT5ACCOUNT",
};

export const CLIENTBANKS__ACTIONS = {
  CLIENTBANKS: "CLIENTBANKS",
  CREATECLIENTBANK: "CREATECLIENTBANK",
  CLIENTCRYPTOS: "CLIENTCRYPTOS",
  CREATECLIENTCRYPTO: "CREATECLIENTCRYPTO",
};

export const MAM__ACTIONS = {
  GETALLMAM: "GETALLMAM",
  GETALLPAMM: "GETALLPAMM",
  GETALLINVESTORS: "GETALLINVESTORS",
  GETALLCOPYTRADE: "GETALLCOPYTRADE",
  GETMONTHLYTRADES: "GETMONTHLYTRADES",
  GETWEEKLYTRADES: "GETWEEKLYTRADES",
  GETTOPTRADESBYSYMBOL: "GETTOPTRADESBYSYMBOL",
  GETMANAGERPROFITLOSS: "GETMANAGERPROFITLOSS",
  GETMAMMANAGERSTATISTICS: "GETMAMMANAGERSTATISTICS",
  GETMAMMANAGERINVESTORS: "GETMAMMANAGERINVESTORS",
  CHANGEINVESTORSTATUS: "CHANGEINVESTORSTATUS",
  CHANGEMANAGERSTATUS: "CHANGEMANAGERSTATUS",
  REMOVEINVESTOR: "REMOVEINVESTOR",
  GETLIVEORDERS: "GETLIVEORDERS",
  GETREPORTS: "GETREPORTS",
  COMMISSIONSTAB: "COMMISSIONSTAB",
  COMMISSIONSHISTORYTAB: "COMMISSIONSHISTORYTAB",
  UPDATEINVESTORCOMMISSION: "UPDATEINVESTORCOMMISSION",
};

export const TRADEMASTER__ACTIONS = {
  GETALLMANAGER: "GETALLMANAGER",
  GETRADEMASTERINVESTORSTATISTICS: "GETRADEMASTERINVESTORSTATISTICS",
  GETINVESTORCLIENTS: "GETINVESTORCLIENTS",
  CHANGEINVESTORSTATUS: "CHANGEINVESTORSTATUS",
};

export const CONTEST__ACTIONS = {
  GETCONTEST: "GETCONTEST",
  GETALLCONTEST: "GETALLCONTEST",
  GETALLUPCOMINGCONTEST: "GETALLUPCOMINGCONTEST",
  GETALLRUNNINGCONTEST: "GETALLRUNNINGCONTEST",
  GETALLFINISHEDCONTEST: "GETALLFINISHEDCONTEST",
  GETALLCONTESTACCTYPES: "GETALLCONTESTACCTYPES",
  UPDATECONTEST: "UPDATECONTEST",
  VIEWFINISHEDCONTEST: "VIEWFINISHEDCONTEST",
  VIEWRUNNINGCONTEST: "VIEWRUNNINGCONTEST",
  VIEWUPCOMINGCONTEST: "VIEWUPCOMINGCONTEST",
  APPROVEDPARTICIPANTS: "APPROVEDPARTICIPANTS",
  PENDINGPARTICIPANTS: "PENDINGPARTICIPANTS",
  ALLUPCOMINGPARTICIPANTS: "ALLUPCOMINGPARTICIPANTS",
  ALLRUNNINGPARTICIPANTS: "ALLRUNNINGPARTICIPANTS",
  ALLFINISHEDPARTICIPANTS: "ALLFINISHEDPARTICIPANTS",
  UPDATECONTESTANTSTATUS: "UPDATECONTESTANTSTATUS",
  CREATECONTEST: "CREATECONTEST",
};

export const COMMISSIONTREE__ACTIONS = {
  GETCOMMISSIONSETTINGS: "GETCOMMISSIONSETTINGS",
  SPLITTOTALCOMMISSION: "SPLITTOTALCOMMISSION",
  ADDCOMMISSIONSETTINGSCONFIG: "ADDCOMMISSIONSETTINGSCONFIG",
  ADDCOMMISSIONTREE: "ADDCOMMISSIONTREE",
  ALLCOMMISSIONTREES: "ALLCOMMISSIONTREES",
  VIEWCOMMISSION: "VIEWCOMMISSION",
  UPDATECOMMISSIONTREE: "UPDATECOMMISSIONTREE",
};

export const IBREQUEST__ACTIONS = {
  ALLPENDINGIBREQUEST: "ALLPENDINGIBREQUEST",
  ALLREJECTEDIBREQUEST: "ALLREJECTEDIBREQUEST",
  LATESTIBREQUEST: "LATESTIBREQUEST",
  UPDATEIBREQ: "UPDATEIBREQ",
  TOPIBDETAILS: "TOPIBDETAILS",
  TOPIBDETAILSFILTER: "TOPIBDETAILSFILTER",
  ALLTOPPERFORMEDIB: "ALLTOPPERFORMEDIB",
};

export const LOTCHART__ACTIONS = {
  TRADINGLOTCHART: "TRADINGLOTCHART",
};

export const PARTNERLIST__ACTIONS = {
  PARTNERLIST: "PARTNERLIST",
  DASHBOARDIBREQUEST: "DASHBOARDIBREQUEST",
  ALLPARTNERLIST: "ALLPARTNERLIST",
  DASHBOARDPARTNERLISTS: "DASHBOARDPARTNERLISTS",
  CLIENTTREE: "CLIENTTREE",
  PARTNERSUMMARY: "PARTNERSUMMARY",
  COMMISSIONHISTORY: "COMMISSIONHISTORY",
  WITHDRAWALS: "WITHDRAWALS",
  ADVANCEDRATES: "ADVANCEDRATES",
  ADVANCEDRATESCOMMISSIONTREE: "ADVANCEDRATESCOMMISSIONTREE",
  UPDATECOMMISSIONRATES: "UPDATECOMMISSIONRATES",
  UPDATECOMMISSIONSTATUS: "UPDATECOMMISSIONSTATUS",
  ADDCLIENTLEVELONE: "ADDCLIENTLEVELONE",
  IBWITHDRAWAL: "IBWITHDRAWAL",
};

export const ASSIGNACCTYPE__ACTIONS = {
  ALLMASTERIB: "ALLMASTERIB",
  MASTERIBDATATABLE: "MASTERIBDATATABLE",
  UNIQUECOUNTRIES: "UNIQUECOUNTRIES",
  ASSIGNACCTYPE: "ASSIGNACCTYPE",
  ASSIGNSINGLEIB: "ASSIGNSINGLEIB",
};

export const LEVELUNLOCKSETTINGS__ACTIONS = {
  LEVELUNLOCKSETTINGS: "LEVELUNLOCKSETTINGS",
  POSTLEVELUNLOCKSETTINGS: "POSTLEVELUNLOCKSETTINGS",
  POSTPARTNERLEVELUNLOCKSETTINGS: "POSTPARTNERLEVELUNLOCKSETTINGS",
  PARTNERLEVELUNLOCKSETTINGS: "PARTNERLEVELUNLOCKSETTINGS",
};

export const TRADABLEBONUS__ACTIONS = {
  TRADABLEBONUSHISTORY: "TRADABLEBONUSHISTORY",
  DIRECTPROVIDETRADABLEBONUS: "DIRECTPROVIDETRADABLEBONUS",
};

export const MAMWALLET__ACTIONS = {
  MANAGERSCOMMISSIONHISTORY: "MANAGERSCOMMISSIONHISTORY",
  // INVESTORSCOMMISSIONHISTORY: "INVESTORSCOMMISSIONHISTORY",
  WALLETTRX: "WALLETTRX",
  UPDATEWALLETWITHDRAW: "UPDATEWALLETWITHDRAW",
  MANAGERSWALLETINFO: "MANAGERSWALLETINFO",
  INVESTORSWALLETINFO: "INVESTORSWALLETINFO",
  CREATEMAMWALLETWITHDRAW: "CREATEMAMWALLETWITHDRAW",
  CREATEMAMWALLETINTX: "CREATEMAMWALLETINTX",
};
